import dayjsGenerateConfig from 'bonree-picker/lib/generate/dayjs';
import generatePicker from './generatePicker';
const DatePicker = generatePicker(dayjsGenerateConfig);
export default DatePicker;
